export default "__VITE_ASSET__DmTXGWty__"